import { View } from './view'

export const MainPlatform = View
